const containers = document.querySelectorAll('.js-product-advisor')

containers?.forEach((container) => {

  const videoContainer = container?.querySelector(".js-video-container")
  const video = videoContainer?.querySelector("video")
  const play = videoContainer?.querySelector(".js-play")
  const pause = videoContainer?.querySelector(".js-pause")
  const poster = videoContainer?.querySelector("img")

  play?.addEventListener('click', () => {
    // hide play
    play?.classList.add('hide')
    
    // show pause
    pause?.classList.remove('hide')

    // play video
    video?.play()

    // hide poster
    poster?.classList.add('hidden')
  })

  pause?.addEventListener('click', () => {
    // hide pause
    pause?.classList.add('hide')

    // show play
    play?.classList.remove('hide')

    // pause video
    video?.pause()

    // show poster
    poster?.classList.remove('hidden')
  })
})